<template>
  <div class="row my-5" style="justify-content:space-between;">
    <div class="col-2 col-md-3 ">
      <div
        :key="group_key"
        v-for="group_key in sortedGroupKeys(this.photo_groups)"
        class="year-container"
      >
        <div
          class="year-tooltip-container ml-2"
          style="position: sticky; top:15vh;"
        >
          <div class="dot"></div>
          <div class="year-tooltip">
            <h4 class="p-1">{{ group_key }}</h4>
          </div>
        </div>
        <div class="intro-fade-in-left-fast row p-4">
          <Thumbnail
            @select-thumbnail="change_selection(photo.url)"
            :selected="isSelected(photo.url)"
            :key="photo.url"
            v-for="photo in photo_groups[group_key].items"
            :title="photo.title"
            :url="photo.thumbnail_url"
            :display_url="photo.url"
          />
        </div>
      </div>
    </div>
    <div
      class="intro-fade-in-right-fast col-7 mb-5 ml-5 mr-5"
      style=" position:sticky; top:10vh; height:80vh;"
    >
      <PhotoDisplay
        v-if="selected"
        :title="selected.title"
        :url="selected.url"
      />
    </div>
  </div>
</template>

<script>
import Thumbnail from "./Thumbnail.vue";
import PhotoDisplay from "./PhotoDisplay.vue";
import formatDistance from "date-fns/formatDistance";
import compareDesc from "date-fns/compareDesc";

export default {
  name: "Gallery",
  data() {
    return { selectedDisplayPhoto: null };
  },
  props: {
    gallery: {
      title: String,
      admin_urls: Object,
      photos: Array,
      description: String,
    },
    group_key: String,
  },
  components: {
    Thumbnail,
    PhotoDisplay,
  },
  computed: {
    photo_groups: function() {
      const groups = this.gallery.photos.reduce((acc, currentValue) => {
        let groupKey = null;
        let orderKey = null;
        switch (this.group_key) {
          case "year":
            orderKey = new Date(currentValue.date_taken);
            groupKey = currentValue[this.group_key];
            break;
          case "day":
            orderKey = new Date(currentValue.date_taken);
            console.log(orderKey)
            groupKey = formatDistance(
              new Date(currentValue.date_taken),
              new Date(),
              { addSuffix: true }
            );
            break;
          default:
            break;
        }
        if (groupKey) {
          if (!acc[groupKey]) {
            acc[groupKey] = { order: orderKey, items: [] };
          }
          acc[groupKey] = {
            order: acc[groupKey].order,
            items: [...acc[groupKey].items, currentValue],
          };
        }
        return acc;
      }, {});
      return groups;
    },
    selected: function() {
      if (this.selectedDisplayPhoto !== null) {
        return this.selectedDisplayPhoto;
      }
      if (this.gallery.photos !== null && this.gallery.photos.length > 0) {
        return {
          title: this.gallery.photos[0].title,
          url: this.gallery.photos[0].url,
        };
      }
      return null;
    },
  },
  methods: {
    change_selection(absolute_url, title) {
      this.selectedDisplayPhoto = {
        url: absolute_url,
        title: title,
      };
    },
    sortedGroupKeys: (groups) => {
      var keys = Object.keys(groups);
      keys.sort((a, b) => compareDesc(groups[a].order, groups[b].order));
      return keys;
    },
    isSelected: function(url) {
      return this.selected ? url === this.selected.url : false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
